import React from "react";
import { NeoBadge } from "../../../../../components/Common";
import { WOD_COMPONENT_TYPES, WOD_FORMATS, WOD_SCORE_TYPES } from "../../domain/wod/constants";

const getLabel = (items, value) => items.find(item => item.value === value)?.label || value || "-";

const WodBlockSummary = ({ block = {} }) => {
    const movements = block.sets || [];
    const equipment = Array.from(new Set(
        movements
            .flatMap(item => [item.load, item.equipment].flat())
            .filter(Boolean)
    ));
    const totalItems = movements.length;
    const scoring = getLabel(WOD_SCORE_TYPES, block.scoreType);
    const format = getLabel(WOD_FORMATS, block.format);
    const component = getLabel(WOD_COMPONENT_TYPES, block.componentType);

    return (
        <div className="wod-block-summary">
            <div className="d-flex flex-wrap align-items-center gap-2">
                <NeoBadge variant="dark">{component}</NeoBadge>
                <span className="neo-stat-badge">{format}</span>
                <span className="neo-stat-badge">Score: {scoring}</span>
                {block.timeCap && <span className="neo-stat-badge">Time cap: {block.timeCap}</span>}
                {block.rounds && <span className="neo-stat-badge">Rounds: {block.rounds}</span>}
                <span className="neo-stat-badge">{totalItems} movimento{totalItems !== 1 ? "s" : ""}</span>
            </div>
            {(block.stimulus || block.scalingNotes || equipment.length > 0) && (
                <div className="mt-2 d-flex flex-column gap-1">
                    {block.stimulus && (
                        <span className="font-size-12 text-muted">
                            <strong>Estímulo:</strong> {block.stimulus}
                        </span>
                    )}
                    {block.scalingNotes && (
                        <span className="font-size-12 text-muted">
                            <strong>Scaling:</strong> {block.scalingNotes}
                        </span>
                    )}
                    {equipment.length > 0 && (
                        <span className="font-size-12 text-muted">
                            <strong>Referências de carga/material:</strong> {equipment.join(", ")}
                        </span>
                    )}
                </div>
            )}
        </div>
    );
};

export default WodBlockSummary;
